import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ChecklistSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ChecklistSVG;
